import { createLiminalTheme } from '@liminal/web-ui/theme/createLiminalTheme';
import { brandColors } from '@liminal/brand/palette';

// The admin theme is the shared design system plus the one thing that is
// genuinely admin's own.
//
// This file previously held its own 12-colour palette — a subset missing
// orangeLight, blueDeep, navy, greyLight and greyLighter — plus
// `rgba(158, 140, 120, 0.3)` inlined three times and a card shadow at 0.08
// where the brand spec is 0.05. All of that is now single-sourced.
//
// What stays overridden here, and why:
//
//   Page background. Admin has always sat on cream with white cards, and that
//   contrast is what gives its tables definition. The shared palette follows
//   mobile, where background.primary is white, so admin asks for cream
//   explicitly rather than the shared token being bent to suit one app.
//
// What used to be here and is now gone:
//
//   A typography block overriding h1–h6. It was justified as keeping "MUI's
//   sizes with its original weights", but it had drifted on both axes: h1 sat
//   at 6rem (96px) against the token scale's 36px, and h3–h6 had quietly gone
//   from bold to semibold. None of the sizes were on the scale at all.
//
//   The cost was not cosmetic. Every shared component that renders a heading
//   looked different here than in Storybook, and `@liminal/web-ui/display/PageHeader`
//   renders an h1 — so adopting it would have produced a 96px page title.
//   Admin's headings are now the shared scale, which is smaller. That is the
//   intended change, not a regression.
//
//   A `MuiCssBaseline` override repainting the body cream. The shared baseline
//   hardcoded `background.primary` instead of reading the palette, so it
//   painted white over the line above. It reads `palette.background.default`
//   now, so `background.default` below is enough on its own.
//
//   `export { brandColors }`. Nothing imported it; call sites take the token
//   from `@liminal/brand` directly.

export const liminalTheme = createLiminalTheme({
  palette: {
    background: { default: brandColors.cream, paper: brandColors.white },
  },
});
